<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ANd">
<section class="chapter" epub:type="chapter" id="section_level_h1_01" role="doc-chapter" title="JANUARY 17: Protection 24/7">
<h1 class="chapter" id="pA4Ya"><a href="#/contents#AB_ch18" id="AB_cha18">JANUARY 17<br/><br/> <span class="chapter2">Protection 24/7</span></a></h1>
<blockquote>
<p class="ext" id="pAOzH"><em>The L<span class="smallcaps">ORD</span> is my rock and my fortress and my deliverer; the God of my strength, in whom I will trust.</em></p>
</blockquote>
<p class="right" id="pAq43">—2 Samuel 22:2–3</p>
<p class="noind" id="Aj4B"><span class="dcap"><b>T</b></span>he surf was high but intermittent, and the occasionally crashing waves kept few people out of the water. In fact one of those beachgoers was thanking God for providing the beautiful day and inviting surf.</p>
<p id="pAjXD">The wave that landed Ellen on her head was about six feet high as it broke. She got herself out of the water and joined her friends. Ellen mentioned that her back was sore. Fortunately one of her cohorts was an experienced EMT.</p>
<p id="pAr2y">Because of the seriousness of back injuries, the friend insisted on calling an ambulance. Although she assured everyone, “I’ll be okay,” Ellen was transported—lights and sirens—to the local emergency room.</p>
<p id="pAZg5">There the young woman learned that when she landed on her head, an injury had occurred in the upper part of her spinal column. Any such injury puts the spinal cord at risk. “It’s a good thing you came in today,” the <span class="spell">ER</span> doctor said. “With the wrong movement, you could have been paralyzed if you’d waited.”</p>
<p id="pAXBG">Thank God: when we hesitate to check out sudden pains caused by harsh waters, He is available to save us from life-altering injury to our bodies or souls.</p>
<p class="left1" id="pAMIy"><em>Thank You, Lord, for protecting us from the near misses we are aware of as well as those we aren’t.</em></p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter18.vue?e25158e4